import { useIntl } from 'react-intl';

import { Perk } from '@/components/Perk/Perk';
import type { ServicePerkType } from '@/integrations/contentful';
import { messages } from '@/messages/boutique';

import * as S from './BoutiqueService.styles';
type BoutiqueServiceProps = {
  offersBoutiquePickUp: boolean;
  offersServiceYourWatch: boolean;
};
export const BoutiqueService = ({
  offersBoutiquePickUp,
  offersServiceYourWatch,
}: BoutiqueServiceProps) => {
  const { formatMessage } = useIntl();
  const boutiquePickUpNumber = offersBoutiquePickUp ? 1 : 0;
  const serviceWatchNumber = offersServiceYourWatch ? 1 : 0;
  const gridItemsNumber = 2 + boutiquePickUpNumber + serviceWatchNumber;
  return (
    <S.StyledFlex>
      <S.Wrapper>
        <S.StyledGrid
          gridItemsNumber={gridItemsNumber}
          offersBoutiquePickUp={offersBoutiquePickUp}
        >
          <S.ServicBox>
            <S.PerkBox>
              <Perk
                iconSize='large'
                type={'buyingAWatch' as ServicePerkType}
                variant='grey'
              >
                <S.Text>{formatMessage(messages.buyingAWatch)}</S.Text>
              </Perk>
            </S.PerkBox>
          </S.ServicBox>
          <S.ServicBox>
            <S.PerkBox>
              <Perk
                iconSize='large'
                type={'buyingAStrap' as ServicePerkType}
                variant='grey'
              >
                <S.Text>{formatMessage(messages.buyingAStrap)}</S.Text>
              </Perk>
            </S.PerkBox>
          </S.ServicBox>
          {offersBoutiquePickUp && (
            <S.ServicBox>
              <S.PerkBox>
                <Perk
                  iconSize='large'
                  type={'pickUpInBoutique' as ServicePerkType}
                  variant='grey'
                >
                  <S.Text>{formatMessage(messages.pickUpInBoutique)}</S.Text>
                </Perk>
              </S.PerkBox>
            </S.ServicBox>
          )}
          {offersServiceYourWatch && (
            <S.ServicBox>
              <S.PerkBox>
                <Perk
                  iconSize='large'
                  type={'serviceYourWatch' as ServicePerkType}
                  variant='grey'
                >
                  <S.Text>{formatMessage(messages.serviceYourWatch)}</S.Text>
                </Perk>
              </S.PerkBox>
            </S.ServicBox>
          )}
        </S.StyledGrid>
      </S.Wrapper>
    </S.StyledFlex>
  );
};
